import { createApp } from 'vue'
import game from './components/game.vue'
import 'vant/lib/index.css'
import vant from 'vant';
document.title = "猫了个咪"
createApp(game).use(vant).mount('#app')